import { TOPIC_CONTENT_SOURCES, type TopicContentSource } from "./topic-content-sources";

const sources = [
  {
    sourceId: "citizenship-source-common-bond",
    topicId: "citizenship",
    title: "Australian Citizenship - Our Common Bond",
    publisher: "Department of Home Affairs",
    url: "https://immi.homeaffairs.gov.au/citizenship/test-and-interview/our-common-bond",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "공식 본문에서 test resource, knowledge scope와 community-language booklet 확인",
    reviewStatus: "live_verified",
    claimScope: "citizenship test official study resource와 assessed knowledge·values",
    followUp: "시험 전 current English testable edition과 appointment instructions 확인",
  },
  {
    sourceId: "citizenship-source-processing",
    topicId: "citizenship",
    title: "Citizenship processing times",
    publisher: "Department of Home Affairs",
    url: "https://immi.homeaffairs.gov.au/citizenship/citizenship-processing-times",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "공식 본문에서 monthly updates, case-by-case variance와 complete application guidance 확인",
    reviewStatus: "live_verified",
    claimScope: "application and ceremony processing-time guides and limitations",
    followUp: "current monthly table, individual requests와 ceremony wait information 재확인",
  },
  {
    sourceId: "citizenship-source-ceremony",
    topicId: "citizenship",
    title: "Citizenship ceremony",
    publisher: "Department of Home Affairs",
    url: "https://immi.homeaffairs.gov.au/citizenship/ceremony",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-16",
    verificationMethod: "공식 본문에서 pledge requirement, approval 후 invitation과 final step 확인",
    reviewStatus: "live_verified",
    claimScope: "approval 후 ceremony invitation, pledge와 citizenship completion",
    followUp: "local invitation, identity, attendance·reschedule와 certificate arrangements 확인",
  },
] as const satisfies readonly TopicContentSource[];

const target = TOPIC_CONTENT_SOURCES as unknown as TopicContentSource[];
for (const source of sources) if (!target.some((item) => item.sourceId === source.sourceId)) target.push(source);
